import { FormBuilder } from '@angular/forms';
import { ExtendedKeyUsages } from 'src/app/shared/entities/extended-key-usages';

export function buildExtendedKeyUsageGroup(
  fb: FormBuilder,
  initialValue?: {
    criticalExtendedKeyUsage?: boolean;
    extendedKeyUsages?: Partial<Record<ExtendedKeyUsages, boolean>>;
  },
) {
  const config: Record<string, [boolean]> = {};
  Object.values(ExtendedKeyUsages).forEach(usage => {
    config[usage] = [!!initialValue?.extendedKeyUsages?.[usage]];
  });
  return fb.nonNullable.group({
    criticalExtendedKeyUsage: [!!initialValue?.criticalExtendedKeyUsage],
    extendedKeyUsages: fb.nonNullable.group(config),
  });
}

export interface ExtendedKeyUsagesFormValue {
  extendedKeyUsages?: Partial<Record<ExtendedKeyUsages, boolean>>;
  criticalExtendedKeyUsage?: boolean;
}

export function extendedKeyUsagesFormValueToDto(
  formValue: ExtendedKeyUsagesFormValue | null | undefined,
): {
  extendedKeyUsages: string[];
  criticalExtendedKeyUsage: boolean;
} {
  if (!formValue) {
    return {
      extendedKeyUsages: [],
      criticalExtendedKeyUsage: false,
    };
  }
  const keyUsages: Partial<Record<ExtendedKeyUsages, boolean>> =
    formValue.extendedKeyUsages ?? {};
  const keyUsagesArr: string[] = [];
  Object.values(ExtendedKeyUsages).forEach(id => {
    if (keyUsages[id]) {
      keyUsagesArr.push(id);
    }
  });
  return {
    extendedKeyUsages: keyUsagesArr,
    criticalExtendedKeyUsage: !!formValue.criticalExtendedKeyUsage,
  };
}

export function extendedKeyUsagesFormValueFromDto(dto: {
  extendedKeyUsages: string[] | null | undefined;
  criticalExtendedKeyUsage: boolean | null | undefined;
}): ExtendedKeyUsagesFormValue {
  const extendedKeyUsages: Partial<Record<ExtendedKeyUsages, boolean>> = {};
  const usages = new Set(dto.extendedKeyUsages);
  Object.values(ExtendedKeyUsages).forEach(usage => {
    extendedKeyUsages[usage] = usages.has(usage);
  });
  const criticalExtendedKeyUsage = !!dto.criticalExtendedKeyUsage;
  return { extendedKeyUsages, criticalExtendedKeyUsage };
}
